import { NgFor, NgIf, SlicePipe, TitleCasePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule, } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { CategoryElement, DepartmentsFilters, Brand, Subcategory, Option } from '@models/departments.model';
import { TranslateModule } from '@ngx-translate/core';
import { ORDER_OPTIONS_LIST } from '@shared/utils';

@Component({
  selector: 'app-filter-modal',
  templateUrl: './filter-modal.component.html',
  styleUrls: ['./filter-modal.component.scss'],
  standalone: true,
  imports: [MatDialogModule, MatInputModule, MatButtonModule, TranslateModule, MatIconModule, NgIf, MatCheckboxModule, MatFormFieldModule, FormsModule, ReactiveFormsModule, TitleCasePipe, NgFor, MatRadioModule, SlicePipe]
})
export class FilterModalComponent {
  public minPriceForm = new FormControl();
  public maxPriceForm = new FormControl();

  public categories: CategoryElement[] = [];
  public subCategories: Subcategory[] = [];

  public brands: Brand[] = [];
  public filters: DepartmentsFilters;
  public orderList = ORDER_OPTIONS_LIST;
  public isSearch = false;
  public optionSelected: Option;
  public from: string | undefined;
  constructor(
    private dialogRef: MatDialogRef<FilterModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { subCategories: Subcategory[]; brands: Brand[]; filters: DepartmentsFilters; type: string; orderList: any, optionSelected?: Option, from?: string }
  ) {
    this.subCategories = this.data.subCategories;
    this.brands = this.data.brands;
    this.filters = this.data.filters;
    this.orderList = this.data.orderList;
    this.isSearch = this.orderList[0].value === '';
    this.from = data.from;
    if (data.optionSelected) {
      this.optionSelected = data.optionSelected;
    }
  }

  public filterPromotion(event: any): void {
    this.filters.promotion = event.checked;
    this.dialogRef.close({ clear: false, promotion: this.filters.promotion });
  }

  public filterSubCategory(subCategorySelected: Subcategory): void {
    subCategorySelected.checked = !subCategorySelected.checked;
    this.filters.subcategory = subCategorySelected.subcategory;
    this.dialogRef.close({ clear: false, subCategory: subCategorySelected });
  }

  public filterSubCategoryCarrousel(subcategory: string, index: number, event: any): void {
    this.dialogRef.close({ clear: false, filters: { subcategory }, index, event });


  }
  public filterBrand(brand: string, index: number, event: any): void {
    this.dialogRef.close({ clear: false, filters: { brand }, index, event });
  }

  public selectOrder(order: Option): void {
    this.dialogRef.close({ clear: false, order: order, });
  }

  public clearFilters(): void {
    this.dialogRef.close({ clear: true });
  }

  public applyFilters(): void {
    this.dialogRef.close({ clear: false, min_price: this.minPriceForm.value, max_price: this.maxPriceForm.value });
  }
}
